<!-- Card with a header: title, hint and toggles on the right. -->
<script lang="ts">
  import type { Snippet } from "svelte";
  let { title = "", hint, extra, children }: { title?: Snippet | string; hint?: Snippet | string; extra?: Snippet; children: Snippet } = $props();
</script>

<div class="card">
  <div class="card-head">
    <h2>{#if typeof title === "string"}{title}{:else}{@render title()}{/if}</h2>
    {#if hint}<span class="hint">{#if typeof hint === "string"}{hint}{:else}{@render hint()}{/if}</span>{/if}
    {@render extra?.()}
  </div>
  {@render children()}
</div>
